//状態だけ管理(中身はcomponent)
import { create } from "zustand";

const useNotificationStore = create((set) => ({
  notification: null,
  showNotification: (message, type = "success") => {
    set({ notification: { message, type } });
    setTimeout(() => set({ notification: null }), 2000);
  },
  clearNotification: () => set({ notification: null }),
}));

export default useNotificationStore;
